function configs(labels, datasets, showHours) {
  const maxValue = Math.max(...datasets.flatMap((item) => item.data || []));

  const categoryPercentage = Math.min(0.8, Math.max(0.1, labels.length * 0.08));

  const roundedMax = Math.ceil(maxValue / 10) * 10;
  const stepSize = roundedMax / 5;

  return {
    data: {
      labels,
      datasets: datasets.map((item) => ({
        label: item.label,
        borderWidth: 0,
        borderRadius: 2,
        borderSkipped: false,
        backgroundColor: item.backgroundColor,
        data: item.data,
        maxBarThickness: 30,
        categoryPercentage,
        barPercentage: 1,
      })),
    },

    options: {
      responsive: true,
      maintainAspectRatio: false,

      plugins: {
        legend: {
          display: true,
          position: "bottom",
          labels: {
            color: "#000",
          },
        },
      },

      interaction: {
        intersect: false,
        mode: "index",
      },

      scales: {
        y: {
          beginAtZero: true,
          max: roundedMax,

          grid: {
            drawBorder: false,
            color: "#e0e0e0",
          },

          ticks: {
            stepSize,
            color: "#000",
            callback: (value) => (showHours ? `${value} hrs` : value),
          },
        },

        x: {
          grid: {
            display: false,
          },

          ticks: {
            color: "#000",
            maxRotation: 45,
            minRotation: 45,
          },
        },
      },
    },
  };
}

export default configs;
